import React from "react";
import MemberAvatar from "@/components/common/MemberAvatar";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";

/**
 * Profile photo, display name, first name and bio.
 *
 * Extracted verbatim from src/pages/Settings.jsx during the code-quality pass:
 * markup, copy, data-testids and behaviour are unchanged.
 */
export default function ProfileBasicsCard({ user, form, setForm, onPhoto }) {
  return (
    <div className="sm-card p-6 bg-white">
      <div className="flex items-center gap-4">
        <MemberAvatar user={{ ...user, profile_photo: form.profile_photo }} size={72} />
        <div className="min-w-0 flex-1">
          <label className="text-sm font-semibold text-[#1F2A2E]">Profile photo (optional)</label>
          <input
            type="file"
            accept="image/*"
            onChange={onPhoto}
            data-testid="photo-input"
            className="mt-1.5 block w-full max-w-full text-sm"
          />
          {form.profile_photo ? (
            <button
              type="button"
              onClick={() => setForm({ ...form, profile_photo: "" })}
              className="mt-1 text-xs text-[#B42318] underline"
            >
              Remove photo
            </button>
          ) : null}
        </div>
      </div>

      <div className="mt-5 grid gap-4 sm:grid-cols-2">
        <div>
          <label className="text-xs font-bold uppercase tracking-wide text-[#4B5A60]">
            Display name
          </label>
          <Input
            value={form.username}
            onChange={(e) => setForm({ ...form, username: e.target.value })}
            data-testid="settings-username-input"
            className="mt-1.5 h-11 bg-white border-[#E3DED4]"
          />
        </div>
        <div>
          <label className="text-xs font-bold uppercase tracking-wide text-[#4B5A60]">
            First name (optional)
          </label>
          <Input
            value={form.first_name}
            onChange={(e) => setForm({ ...form, first_name: e.target.value })}
            className="mt-1.5 h-11 bg-white border-[#E3DED4]"
          />
        </div>
      </div>

      <div className="mt-4">
        <label className="text-xs font-bold uppercase tracking-wide text-[#4B5A60]">
          A little about you (optional)
        </label>
        <Textarea
          value={form.bio}
          onChange={(e) => setForm({ ...form, bio: e.target.value })}
          rows={3}
          className="mt-1.5 bg-white border-[#E3DED4]"
          placeholder="Sponsors may see this when you request sponsorship."
        />
      </div>
    </div>
  );
}
